import { useTranslation } from 'react-i18n-lite'
import useWorkflow from './useWorkflow'
import { useAppSelector } from 'state/store'
import { ExecutionState } from 'types/workflow'
import { useCallback, useMemo } from 'react'

const useDataFromWorkflow = () => {
  const { t } = useTranslation()
  const { workflowUuid } = useAppSelector((state) => state.interactionModel)

  const { workflow } = useWorkflow({ t, workflowUuid })

  const processState = useMemo(
    () => JSON.parse(workflow?.execution_state || '{}') as ExecutionState,
    [workflow]
  )

  const getVariableFromProcessState = useCallback(
    (identifier: string) => {
      return processState?.data_container?.[identifier]
    },
    [processState]
  )

  return { getVariableFromProcessState }
}

export default useDataFromWorkflow
